import React from "react";
import { motion } from "framer-motion";
import { FaAward, FaUsers, FaStethoscope, FaLeaf } from "react-icons/fa";
import "./TrustSection.css";

// Animation configs
const sectionMotion = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.38, staggerChildren: 0.17 } }
};

const card = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.66 } }
};

export default function MeetCarySection() {
  return (
    <motion.section
      className="meet-cary-section"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.08 }} // triggers as soon as section enters viewport
      variants={sectionMotion}
    >
      <motion.div className="meet-cary-header" variants={card}>
        <img
          src="/cary.png"
          alt="Cary DeClerck with Goldens"
          className="meet-cary-photo"
        />
        <div>
          <h2>Meet Cary DeClerck</h2>
          <p className="meet-cary-tagline">
            Breeder. Grandpa. Animal lover. Trusted friend for your puppy’s first steps.
          </p>
        </div>
      </motion.div>
      
      <motion.div className="meet-cary-icons" variants={sectionMotion}>
        <motion.div className="cary-card" variants={card}>
          <FaAward className="icon-gold" />
          <h3>30+ Years’ Experience</h3>
          <p>Decades of proven, ethical breeding. AKC registered, Embark DNA tested.</p>
        </motion.div>
        <motion.div className="cary-card" variants={card}>
          <FaUsers className="icon-gold" />
          <h3>Family Socialization</h3>
          <p>Seven kids, 22 grandkids. Puppies raised in the heart of real family life.</p>
        </motion.div>
        <motion.div className="cary-card" variants={card}>
          <FaLeaf className="icon-gold" />
          <h3>Unique Farm Upbringing</h3>
          <p>Kangaroos, wallabies, tortoises, birds and more. Every day is a new adventure.</p>
        </motion.div>
        <motion.div className="cary-card" variants={card}>
          <FaStethoscope className="icon-gold" />
          <h3>Health and Transparency</h3>
          <p>Full health records, open visits, and lifetime breeder support.</p>
        </motion.div>
      </motion.div>

      <motion.div className="meet-cary-quote" variants={card}>
        <blockquote>
          “Every puppy leaves our farm confident, loved, and ready for your family, from our home to yours.”
        </blockquote>
         <div className="meet-cary-cite">— Cary DeClerck</div>
      </motion.div>
      
      <motion.div className="meet-cary-actions" variants={card}>
        <a href="/puppies" className="btn-primary">Meet the Puppies</a>
        <a href="/contact" className="btn-outline">Contact Cary</a>
      </motion.div>
    </motion.section>
  );
}
